<template>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <c-card title="법규별 규제사항" class="cardClassDetailForm">
      <template v-slot:card-detail>
        <div
          class="col-12 chemLawRegulCheckbox"
          v-for="(item, idx) in bills"
          :key="idx"
        >
          <div class="chemLawRegulBillDiv">{{ item.regulationBillName }}</div>
          <q-checkbox
            v-for="(regul, _idx) in item.reguls"
            :key="_idx"
            class="customqcbox"
            disable
            dense
            color="orange-custom"
            true-value="Y"
            false-value="N"
            :label="regul.regulatedItemName"
            v-model="regul.val"
          />
        </div>
      </template>
    </c-card>
    <c-dialog :param="popupOptions" />
  </div>
</template>
<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "chemLawHistoryDetail",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmHistoryId: "",
        mdmChemMaterialId: "",
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "regUserDeptName",
            field: "regUserDeptName",
            label: "부서",
            align: "center",
            sortable: true,
          },
          {
            name: "regUserName",
            field: "regUserName",
            label: "수정자",
            align: "center",
            sortable: true,
          },
          {
            name: "regDt",
            field: "regDt",
            label: "수정일시",
            align: "center",
            type: "link",
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      popupOptions: {
        isFull: false,
        width: "100%",
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      reguls: [],
      bills: [],
    };
  },
  computed: {
    gridHeight() {
      return this.contentHeight
        ? String(this.contentHeight - 200) + "px"
        : "500px";
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.mam.chem.materialRegul.historyDetail.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = {
        mdmHistoryId: this.popupParam.mdmHistoryId,
        mdmChemMaterialId: this.popupParam.mdmChemMaterialId,
      };
      this.$http.request((_result) => {
        this.reguls = _result.data;

        this.bills = [];
        if (this.reguls && this.reguls.length > 0) {
          this.bills = this.$_.map(this.reguls, (value) => {
            return {
              regulationBillCd: value["regulationBillCd"],
              regulationBillName: value["regulationBillName"],
              reguls: [],
            };
          });
          this.bills = this.$_.uniqBy(this.bills, (item) => {
            return item.regulationBillCd;
          });
          let i = 1;
          this.$_.forEach(this.bills, (bill) => {
            bill.regulationBillName = i + ". " + bill.regulationBillName;
            bill.reguls = this.$_.filter(this.reguls, {
              regulationBillCd: bill.regulationBillCd,
            });
            i++;
          });
        }
      });
    },
  },
};
</script>
<style>
.lawspan {
  color: #0072c6 !important;
  font-size: 13px !important;
  font-weight: 600;
}
.divchklaw {
  margin-bottom: 10px;
}
.chemLawRegulBillDiv {
  color: #0072c6 !important;
  font-size: 13px !important;
  font-weight: 600;
}
.chemLawRegulCheckbox {
  margin-bottom: 10px;
}
</style>
